import React from "react";
import Dropdown from "./common/Dropdown";
import {
  withStyles,
  Divider,
  Button,
  CircularProgress,
} from "@material-ui/core";
import constants from "../constants";
import { StyledRadioGroup } from "../../../../Dispatch/RouteExecution/DriverPopUp/common/RadioGroup";
import CheckboxGroup from "../../../../Dispatch/RouteExecution/DriverPopUp/common/CheckboxGroup";
import {
  getDoorValue,
  getPrimaryRouteOptions,
  getRouteOptions,
  getRouteTypes,
} from "../utils";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../../appConfigContext";

const styles = (theme) => ({
  formContainer: {
    minHeight: 100,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "100%",
    marginTop: 8,
  },
  dropDownContainer: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: 24,
    minWidth: 180,
  },
  label: {
    marginTop: "5px",
    marginRight: 24,
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize,
    minWidth: 155,
  },
  colorLabel: {
    alignSelf: "center",
    marginRight: 24,
    color: theme.gridTextColor,
    fontSize: theme.headerTextFontSize,
  },
  divider: {
    backgroundColor: theme.AppBGColor,
  },
  colorBox: {
    height: 24,
    width: 24,
    marginRight: 8,
    borderRadius: 4,
    border: "3px solid transparent",
    marginBottom: 8,
    cursor: "pointer",
  },
  selectedColorBox: {
    border: `3px solid${theme.palette.secondary.main} `,
  },
  colorSectionContainer: {
    marginBottom: 24,
  },
  colorSection: { display: "flex", marginTop: 24 },
  colorBoxContainer: {
    display: "flex",
    flexWrap: "wrap",
    minHeight: 54,
  },
  colorErrorLabel: {
    color: theme.errorBorderColor,
    textAlign: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 100,
    width: "100%",
  },
  actionButton: {
    minWidth: "35%",
    marginLeft: 24,
    "&$disabledButton": {
      backgroundColor: theme.iconColor,
    },
  },
  disabledButton: {
    backgroundColor: theme.iconColor,
  },
  circularProgress: {
    color: theme.white,
  },
  dropdownContainer: {
    minWidth: 180,
  },
  typeContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
    marginTop: 24,
  },
  typeLabel: {
    minWidth: "unset",
  },
});

const RouteMappingForm = ({
  classes,
  handleChange,
  onClose,
  updateInProgress,
  onSubmit,
  errorInfo,
  editInfo,
  originalRouteMapping,
  handleRouteTypeChange,
  isExistingFeature,
  configJSON,
  doorData,
  showDoorNumber
}) => {
  const handleClose = () => {
    onClose(false);
  };

  const handleTypeChange = (value) => {
    const selectedTypes = isExistingFeature
      ? [value]
      : value.filter((type) => type.isChecked).map((type) => type.name);
    handleRouteTypeChange?.(selectedTypes);
  };
  return (
    <>
      <div className={classes.formContainer}>
        <div className={classes.dropDownContainer}>
          <span className={classes.label}>Primary Route Name</span>
          <div className={classes.dropdownContainer}>
            <Dropdown
              textFieldProps={{
                variant: "outlined",
                helperText: errorInfo?.primaryRoute,
              }}
              name="primaryRoute"
              isClearable={true}
              error={Boolean(errorInfo?.primaryRoute)}
              onChange={handleChange("primaryRoute")}
              value={getPrimaryRouteOptions(editInfo)}
              options={getRouteOptions([originalRouteMapping.primaryRoute])}
              format={configJSON.routeNameEditParams.format}
              mask={configJSON.routeNameEditParams.mask}
            />
          </div>
        </div>
        <div className={classes.dropDownContainer}>
          <span className={classes.label}>Secondary Route Name</span>
          <div className={classes.dropdownContainer}>
            <Dropdown
              textFieldProps={{
                variant: "outlined",
                helperText: errorInfo?.secondaryRoute,
              }}
              isMulti={true}
              isClearable={true}
              name="secondaryRoute"
              onChange={handleChange("secondaryRoute")}
              error={Boolean(errorInfo?.secondaryRoute)}
              value={getRouteOptions(editInfo.secondaryRoute)}
              options={getRouteOptions(originalRouteMapping.secondaryRoute)}
              format={configJSON.routeNameEditParams.format}
              mask={configJSON.routeNameEditParams.mask}
            />
          </div>
        </div>
        {showDoorNumber && (
          <div className={classes.dropDownContainer}>
            <span className={classes.label}>Door #</span>
            <div className={classes.dropdownContainer}>
              <Dropdown
                textFieldProps={{
                  variant: "outlined",
                  helperText: errorInfo?.door,
                }}
                isClearable
                name="door"
                onChange={handleChange("door")}
                error={Boolean(errorInfo?.door)}
                value={getDoorValue(editInfo.door)}
                options={getRouteOptions(doorData)}
              />
            </div>
          </div>
        )}
        <Divider className={classes.divider} />
        <div className={classes.colorSectionContainer}>
          <div className={classes.colorSection}>
            <span className={classes.colorLabel}>Color</span>
            <div className={classes.colorBoxContainer}>
              {constants.ROUTE_MAPPING_TOOL_COLOR_PALETTE.map(
                (color, colorIndex) => (
                  <div
                    onClick={() => handleChange("selectedColor")(color)}
                    className={`${classes.colorBox} ${
                      editInfo.selectedColor === color
                        ? classes.selectedColorBox
                        : null
                    }`}
                    style={{ backgroundColor: color }}
                    key={`${colorIndex}_${color}`}
                  ></div>
                )
              )}
            </div>
          </div>
          <div className={classes.colorErrorLabel}>
            {errorInfo?.selectedColor}
          </div>
        </div>
        <Divider className={classes.divider} />
        <div className={classes.typeContainer}>
          <span className={`${classes.label} ${classes.typeLabel}`}>
            Route Type
          </span>
          {isExistingFeature ? (
            <StyledRadioGroup
              onChange={handleTypeChange}
              options={getRouteTypes(isExistingFeature, editInfo)}
              value={editInfo.types[0]}
            />
          ) : (
            <CheckboxGroup
              options={getRouteTypes(isExistingFeature, editInfo)}
              onChange={handleTypeChange}
            />
          )}
        </div>
        <div className={classes.colorErrorLabel}>{errorInfo?.types}</div>
      </div>
      <div className={classes.footer}>
        <Button
          color="primary"
          variant="outlined"
          classes={{
            root: classes.actionButton,
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          classes={{
            root: classes.actionButton,
            disabled: classes.disabledButton,
          }}
          onClick={onSubmit}
        >
          {updateInProgress ? (
            <CircularProgress
              size={16}
              classes={{ root: classes.circularProgress }}
            />
          ) : (
            "Mark Area"
          )}
        </Button>
      </div>
    </>
  );
};

export default compose(withAppConfig, withStyles(styles))(RouteMappingForm);